// key and value should be the same

export const availableTutorials = {
	quadZoom: 'quadZoom',
	newObliquityLineDot: 'newObliquityLineDot',
	customizeToolbar: 'customizeToolbar',
	customizeToolbarOldMenu: 'customizeToolbarOldMenu',
	patientChart: 'patientChart',
};
